'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemFlyout = MenuItemFlyout;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _blocks = require('../../blocks');

var _MenuItemTitle = require('./MenuItemTitle');

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuSubItem = require('./MenuSubItem');

var _MenuSubItem2 = _interopRequireDefault(_MenuSubItem);

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuItemFlyout(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      isActive = _ref.isActive,
      isHighlighted = _ref.isHighlighted,
      isFlyoutOpen = _ref.isFlyoutOpen,
      isMenuExpanded = _ref.isMenuExpanded,
      location = _ref.location,
      menuItem = _ref.menuItem,
      menuGroupsLoading = _ref.menuGroupsLoading,
      menuKey = _ref.menuKey,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  var _menuItem$menuSubItem = menuItem.menuSubItems,
      menuSubItems = _menuItem$menuSubItem === undefined ? [] : _menuItem$menuSubItem;


  return _react2.default.createElement(
    _blocks.LeftNav.MenuItemFlyout,
    null,
    _react2.default.createElement(_MenuItemTitle2.default, {
      TextRenderer: TextRenderer,
      expanded: expanded,
      handleExpandMenuClick: handleExpandMenuClick,
      isActive: isActive,
      isHighlighted: isHighlighted,
      isFlyout: true,
      isFlyoutOpen: isFlyoutOpen,
      isMenuExpanded: isMenuExpanded,
      menuItem: menuItem,
      menuGroupsLoading: menuGroupsLoading,
      menuKey: menuKey,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }),
    _react2.default.createElement(
      _blocks.LeftNav.MenusList,
      null,
      menuSubItems.map(function (menuSubItem) {
        return _react2.default.createElement(_MenuSubItem2.default, {
          key: menuSubItem.path || menuSubItem.url,
          isFlyoutOpen: isFlyoutOpen,
          location: location,
          menuSubItem: menuSubItem,
          TextRenderer: TextRenderer
        });
      })
    )
  );
}

MenuItemFlyout.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.bool.isRequired,
  isFlyoutOpen: _propTypes2.default.bool.isRequired,
  isHighlighted: _propTypes2.default.bool.isRequired,
  isMenuExpanded: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-typos
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuKey: _propTypes2.default.string.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

var MenuItemFlyoutWithRouter = (0, _reactRouterDom.withRouter)(MenuItemFlyout);
MenuItemFlyoutWithRouter.displayName = 'MenuItemFlyout';

exports.default = MenuItemFlyoutWithRouter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuItemFlyout.js
// module id = 1674
// module chunks = 2